module.exports = __webpack_public_path__ + "0cabe7b89706e6b5cc41c901e994c5fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/O@2x.png
// module id = 840
// module chunks = 0